import { Box } from "@mui/material";
import React from "react";
import { Fade } from "react-reveal";
import Boxes from "./Box";

const Portfolio = () => {
  const flipkartTech = [
    "REACT JS",
    "MATERIAL UI",
    "PAYTM GATEWAY",
    "EXPRESS JS",
    "MONGOOSE",
  ];
  const AmazonTech = ["REACT JS", "FIREBASE", "CSS", "HTML", "MATERIAL UI"];
  const MicrosoftTech = ["HTML", "TAILWIND CSS"];
  const NotesTech=["HTML","CSS","JAVASCRIPT"]

  return (
    <Box style={{marginTop:'92px'}} id="Project">
      <Fade right big>
      <h1 style={{ color:'#010B30',marginLeft:'44px'}}>My Projects :</h1>
      <Boxes
        image="https://i.postimg.cc/SKzJG10G/flipkart-Clone.jpg"
        title="Flipkart Clone"
        description="It is a full stack Flipkart Clone . In this we can add product to our basket , we can sign in and login , and also added paytm gateway to do transaction however it is just a dummy.It is fully responsive."
        technology={flipkartTech}
        webSiteLink="https://flipkartclonemernwebsite.herokuapp.com/"
        github="https://github.com/Ayush-Dahala/FlipkartClone"
        image1="https://i.postimg.cc/zDwHMQyt/Amazon-Clone.jpg"
        title1="Amazon Clone"
        description1="It is a full stack Amazon Clone . In this we can add product to our basket , we can sign in and login , and also added paytm gateway to do transaction however it is just a dummy.It is fully responsive."
        technology1={AmazonTech}
        webSiteLink1="https://clone-7f24c.web.app/"
        github1="https://github.com/Ayush-Dahala/AmazonClone"
      />
      
      <Boxes
        image="https://i.postimg.cc/pLSmzbST/Microsoft-Clone.jpg"
        title="Microsoft Clone"
        description="It is a clone of Microsoft landing page"
        technology={MicrosoftTech}
        webSiteLink='https://ayushwork.live/'
        github='https://github.com/Ayush-Dahala/Microsoft-clone'
        image1="https://i.postimg.cc/Jz0ys4Pv/Notes.jpg"
        title1="Notes App"
        description1="It is note taking app. Your notes will be stored in local Storage so as you refresh the page content will not get lost"
        technology1={NotesTech}
        webSiteLink1='https://superb-mooncake-a0eabf.netlify.app/'
        github1='https://github.com/Ayush-Dahala/JavaScript-work/tree/main/JavaScipt%20COde/Project1'
      />
      </Fade>
    </Box>
  );
};

export default Portfolio;
